import { TableColumn } from '@ui/aos-lib';
import {
  CustomizableColumnComponent,
  CustomizableColumnType,
  CustomizableTableColumn,
  CustomizableTableColumnValue
} from '@portal/shared/components/listing-table/components/customizable-column.component';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { getUrlPathForDeviceTypeName } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.helpers';
import { DeviceType } from 'src/app/pages/equipment/devices/components/devices.models';
import { FieldOperationsSensorsListItem } from './field-operations-sensors.types';

const sensorsPath = getUrlPathForDeviceTypeName(DeviceType.ExactaGuard);

export const createFieldOperationsSensorsColumns = (): (TableColumn | CustomizableTableColumn)[] => [
  {
    field: 'lastFieldOperationDate',
    title: TranslateRegistry.get.INSTALLATION_HISTORY.TABLE.OPERATION_DATE_TIME,
    width: 200,
    sortable: true
  },
  {
    field: 'commDeviceId',
    title: TranslateRegistry.get.INSTALLATION_HISTORY.TABLE.COMM_DEVICE_ID,
    width: 200,
    sortable: true,
    link: {
      getLink: (dataItem): string => `devices/${sensorsPath}/${dataItem['deviceUID']}`
    }
  },
  {
    field: 'installationReason',
    title: TranslateRegistry.get.INSTALLATION_HISTORY.TABLE.REASON,
    width: 200,
    sortable: true
  },
  {
    field: 'sensorSerialNumber',
    title: TranslateRegistry.get.INSTALLATION_HISTORY.TABLE.SENSOR_SERIAL_NUMBER,
    width: 200,
    sortable: false,
    cmp: CustomizableColumnComponent,
    options: {
      columnType: CustomizableColumnType.LINK,
      columnValues: (tableItem): CustomizableTableColumnValue[] =>
        (tableItem as unknown as FieldOperationsSensorsListItem).childDevices.map(child => ({
          text: child.serialNumber ?? '',
          routerLink: ['/devices', getUrlPathForDeviceTypeName(DeviceType.RMDSensor), child.deviceUID ?? '']
        }))
    }
  },
  {
    field: 'port',
    title: TranslateRegistry.get.INSTALLATION_HISTORY.TABLE.PORT,
    width: 100,
    sortable: false,
    cmp: CustomizableColumnComponent,
    options: {
      columnType: CustomizableColumnType.TEXT,
      columnValues: (tableItem): CustomizableTableColumnValue[] =>
        (tableItem as unknown as FieldOperationsSensorsListItem).childDevices.map(child => ({
          text: `${child.port ?? ''}`
        }))
    }
  },
  {
    field: 'gnnId',
    title: TranslateRegistry.get.INSTALLATION_HISTORY.TABLE.GNN_ID,
    width: 150,
    sortable: false,
    cmp: CustomizableColumnComponent,
    options: {
      columnType: CustomizableColumnType.TEXT,
      columnValues: (tableItem): CustomizableTableColumnValue[] =>
        (tableItem as unknown as FieldOperationsSensorsListItem).childDevices.map(child => ({
          text: child.serviceLocationIds ?? ''
        }))
    }
  },
  {
    field: 'lastChangedBy',
    title: TranslateRegistry.get.INSTALLATION_HISTORY.TABLE.INSTALLED_BY,
    width: 200,
    sortable: true
  }
];
